import { db } from "../firebase"
import {
  updateDoc,
  arrayUnion,
  deleteDoc,
  setDoc,
  addDoc,
  collection,
  doc,
  getDoc,
  query,
  getDocs,
  where,
  orderBy,
  serverTimestamp,
  onSnapshot,
} from "firebase/firestore"
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
  listAll,
  deleteObject,
} from "firebase/storage"
import moment from "moment"
import { generateTimestamp } from "../utils/generateTimestamp"

export const storage = getStorage()

export const listenUserList = (callback) => {
  // Modified: Added function for listening to user list changes
  const q = query(collection(db, "users"), orderBy("createdAt", "desc"))
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const userList = []
    querySnapshot.forEach((doc) => {
      const { displayName, idCard, loanNo, approvalStatus, timestamp } =
        doc.data()
      if (idCard !== "superadmin") {
        userList.push({
          idCard: idCard,
          displayName: displayName,
          docId: doc.id,
          loanNo: loanNo,
          approvalStatus: approvalStatus,
          timestamp: timestamp,
        })
      }
    })
    callback(userList)
  })
  return unsubscribe
}

export const listenUser = (idCard, callback) => {
  const unsubscribe = onSnapshot(doc(db, "users", idCard), (doc) => {
    callback(doc.data())
  })
  return unsubscribe
}

export const listenUnsignDocs = (idCard, callback) => {
  const q = query(collection(db, "DocToSign"), where("idCard", "==", idCard))
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const docs = []
    querySnapshot.forEach((doc) => {
      docs.push(doc.data())
    })
    callback(docs)
  })
  return unsubscribe
}

export const listenSignedDocs = (idCard, callback) => {
  const q = query(collection(db, "SignedDoc"), where("idCard", "==", idCard))
  const unsubscribe = onSnapshot(q, (querySnapshot) => {
    const docs = []
    querySnapshot.forEach((doc) => {
      docs.push(doc.data())
    })
    callback(docs)
  })
  return unsubscribe
}

export async function ErrorMsgLogger(id, msg) {
  const docRef = doc(db, "ErrorLog", id)
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    await updateDoc(docRef, {
      files: arrayUnion({
        message: msg,
        timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
      }),
    })
    return (msg = "success")
  } else {
    await setDoc(doc(db, "ErrorLog", id), {
      idCard: id,
      files: [
        {
          message: msg,
          timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
        },
      ],
    })
  }
}

export async function uploadSignedDoc(file, id, filename) {
  let msg = ""
  let downloadURL = ""
  if (!file) return
  const storageRef = ref(storage, `/SignedDoc/${filename}`)
  const uploadTask = uploadBytesResumable(storageRef, file)

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const prog = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      )
    },
    (err) => console.log(err),
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((url) => {
        downloadURL = url
        console.log(downloadURL)
        createUploadSignedDocRec(id, filename, downloadURL)
        deleteUserDoc(id, filename)
      })
    }
  )

  return (msg = "success")
}

export async function createUploadSignedDocRec(id, fileName, downloadURL) {
  try {
    const docRef = doc(db, "SignedDoc", id)
    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        files: arrayUnion({
          fileName: fileName,
          downloadURL: downloadURL,
          isSigned: true,
          timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
        }),
      })
    } else {
      await setDoc(doc(db, "SignedDoc", id), {
        idCard: id,
        files: [
          {
            fileName: fileName,
            downloadURL: downloadURL,
            isSigned: true,
            timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
          },
        ],
      })
    }
  } catch (e) {
    console.error("Error adding document: ", e)
  }
}

export async function uploadFile(file, id) {
  let msg = ""
  let downloadURL = ""
  console.log("file:", file)
  if (!file) return

  // 生成带时间戳的文件名
  const timestamp = generateTimestamp()
  const fileName = `${id}_contract_${timestamp}.pdf`

  // check if doc exist
  const userDocs = []
  const q = query(collection(db, "DocToSign"), where("idCard", "==", id))
  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { files } = doc.data()
    userDocs.push({
      files: files,
    })
  })

  const storageRef = ref(storage, `/DocToSign/${id}/${fileName}`)
  const uploadTask = uploadBytesResumable(storageRef, file)

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const prog = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      )
    },
    (err) => console.log(err),
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((url) => {
        downloadURL = url
        console.log(downloadURL)
        createUploadDocRec(id, fileName, downloadURL)
      })
    }
  )

  return (msg = "success")
}

export async function uploadSupportingFile(file, id) {
  let msg = ""
  let downloadURL = ""
  console.log("file:", file?.name)
  // const fileName = id + "_" + file.name
  const fileName = file?.name
  if (!file) return

  //check if doc exist
  // const userDocs = []
  // const q = query(collection(db, "SupportingFile"), where("idCard", "==", id))
  // const querySnapshot = await getDocs(q)
  // querySnapshot.forEach((doc) => {
  //   const { files } = doc.data()
  //   userDocs.push({
  //     files: files,
  //   })
  // })

  const storageRef = ref(storage, `/SupportingFile/${id}/${fileName}`)
  const uploadTask = uploadBytesResumable(storageRef, file)

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const prog = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      )
    },
    (err) => console.log(err),
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((url) => {
        downloadURL = url
        console.log(downloadURL)
        createUploadDocRec(id, fileName, downloadURL)
      })
    }
  )

  return (msg = "success")
}

export async function createUploadDocRec(id, fileName, downloadURL) {
  try {
    const docRef = doc(db, "DocToSign", id)
    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      await updateDoc(docRef, {
        files: arrayUnion({
          fileName: fileName,
          downloadURL: downloadURL,
          isSigned: false,
          timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
        }),
      })
    } else {
      await setDoc(doc(db, "DocToSign", id), {
        idCard: id,
        files: [
          {
            fileName: fileName,
            downloadURL: downloadURL,
            isSigned: false,
            timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
          },
        ],
      })
    }
  } catch (e) {
    console.error("Error adding document: ", e)
  }
}

export async function getUserAllDocs(id) {
  let error = ""
  const userDocs = []
  const q = query(collection(db, "DocToSign"), where("idCard", "==", id))

  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { files } = doc.data()
    const docId = doc.id
    userDocs.push({
      files: files,
      docId: docId,
    })
  })
  return userDocs
}

export async function getUserSignedDocs(id) {
  let error = ""
  const userDocs = []
  const q = query(collection(db, "SignedDoc"), where("idCard", "==", id))

  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { files } = doc.data()
    const docId = doc.id
    userDocs.push({
      files: files,
      docId: docId,
    })
  })
  return userDocs
}

export async function getUserUnsignDocs(id) {
  let error = ""
  const userDocs = []
  const q = query(collection(db, "DocToSign"), where("idCard", "==", id))

  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { files } = doc.data()
    const docId = doc.id
    userDocs.push({
      files: files,
      docId: docId,
    })
  })
  return userDocs
}

export async function createUser(user) {
  let error = ""
  let success = ""
  const { idCard, password, displayName, loanNo } = user

  const docRef = doc(db, "users", idCard)
  const docSnap = await getDoc(docRef)
  try {
    if (docSnap.exists()) {
      error = "不能新增已註冊身份證號碼"
    } else {
      const docRef = await setDoc(doc(db, "users", idCard), {
        idCard: idCard,
        password: password,
        displayName: displayName,
        phoneNumb: password,
        loanNo: loanNo,
        approvalStatus: "pending_upload",
        timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
        createdAt: serverTimestamp(),
      })

      success = "註冊成功!"
    }
  } catch (e) {
    console.error("Error adding document: ", e)
  }
  return { error, success }
}

//User
export async function getUserDataFromPhone(user) {
  let error = ""
  let result = false
  let userDetail = {}
  const { phoneNumb } = user

  try {
    const q = query(
      collection(db, "users"),
      where("phoneNumb", "==", phoneNumb)
    )

    const querySnapshot = await getDocs(q)

    if (querySnapshot.empty) {
      error = "請輸入正確身份証號碼及密碼"
    } else {
      querySnapshot.forEach((doc) => {
        const { displayName, timestamp, password, approvalStatus } = doc.data()

        const docId = doc.id
        userDetail = {
          displayName: displayName,
          docId: docId,
          approvalStatus: approvalStatus,
          timestamp: timestamp,
          password: password,
        }
        result = true
      })
    }
  } catch (e) {
    console.error(e.message)
  }
  return { error, result, userDetail }
}
export async function getUserData(user) {
  let error = ""
  let result = false
  let userDetail = {}
  const { idCard, password } = user

  try {
    const q = query(collection(db, "users"), where("idCard", "==", idCard))

    const querySnapshot = await getDocs(q)

    console.log(querySnapshot)

    if (querySnapshot.empty) {
      error = "請輸入正確身份証號碼及密碼"
    } else {
      querySnapshot.forEach((doc) => {
        const { displayName, timestamp, password, approvalStatus } = doc.data()

        const docId = doc.id
        userDetail = {
          displayName: displayName,
          docId: docId,
          approvalStatus: approvalStatus,
          timestamp: timestamp,
          password: password,
        }
        result = true
      })
    }
  } catch (e) {
    console.error(e.message)
  }
  return { error, result, userDetail }
}

export async function getUserList() {
  let error = ""
  const userList = []
  const q = query(
    collection(db, "users"),
    // where("idCard", "!=", "superadmin"),
    orderBy("createdAt", "desc")
  )
  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { displayName, idCard, loanNo, approvalStatus, timestamp } =
      doc.data()
    const docId = doc.id
    if (idCard !== "superadmin")
      userList.push({
        idCard: idCard,
        displayName: displayName,
        docId: docId,
        loanNo: loanNo,
        approvalStatus: approvalStatus,
        timestamp: timestamp,
      })
  })
  return userList
}

export async function deleteUser(id) {
  let error = ""
  let msg = ""

  try {
    // Delete user document from Firestore
    await deleteDoc(doc(db, "users", id))

    // Function to delete documents from Firestore collections
    async function deleteDocuments(collectionName) {
      const q = query(collection(db, collectionName), where("idCard", "==", id))
      const querySnapshot = await getDocs(q)

      for (const docSnap of querySnapshot.docs) {
        await deleteDoc(doc(db, collectionName, docSnap.id))
      }
    }

    msg = "deleted"
  } catch (e) {
    error = e.message
    console.error("Error deleting user and related documents: ", e)
  }

  return { msg, error }
}

export function deleteFromStorage(filePath) {
  const deleteRef = ref(storage, filePath)
  // Delete the file
  deleteObject(deleteRef)
    .then(() => {
      // File deleted successfully
    })
    .catch((error) => {})
}

export async function deleteUserDoc(id, fileName) {
  let error = ""
  let userDoctoSignList = []

  const storage = getStorage()
  const fileRef = ref(storage, `DocToSign/${id}/${fileName}`)

  try {
    // Delete the file from Firebase Storage
    await deleteObject(fileRef)

    // Query Firestore to get the document containing the file
    const q = query(collection(db, "DocToSign"), where("idCard", "==", id))
    const querySnapshot = await getDocs(q)

    if (querySnapshot) {
      querySnapshot.forEach(async (docSnap) => {
        const { files } = docSnap.data()
        const updatedFiles = files.filter((file) => file.fileName !== fileName)

        // Update the Firestore document with the new file list
        const docRef = doc(db, "DocToSign", docSnap.id)
        await updateDoc(docRef, { files: updatedFiles })
      })
    }
  } catch (err) {
    error = err.message
    console.error("Error deleting file: ", err)
  }
}

export async function getDocToSign(id) {
  let error = ""
  const userDocs = []
  const q = query(collection(db, "DocToSign"), where("idCard", "==", id))

  const querySnapshot = await getDocs(q)
  querySnapshot.forEach((doc) => {
    const { files } = doc.data()
    const docId = doc.id
    userDocs.push({
      files: files,
      docId: docId,
    })
  })
  return userDocs
}
export async function updateUserPassword(id, newPassword) {
  let error = ""
  let result = ""

  const docRef = doc(db, "users", id)
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    const { displayName, loanNo, approvalStatus, timestamp, phoneNumb } =
      docSnap.data()
    setTimeout(() => {
      updateUserData(displayName, loanNo, approvalStatus, timestamp, phoneNumb)
    }, 1000)
    result = "success"
  } else {
    error = "fail"
  }

  async function updateUserData(
    displayName,
    loanNo,
    approvalStatus,
    timestamp,
    phoneNumb
  ) {
    const userRef = doc(db, "users", id)
    await setDoc(userRef, {
      idCard: id,
      password: newPassword,
      displayName: displayName,
      loanNo: loanNo,
      timestamp: timestamp,
      approvalStatus: approvalStatus,
      phoneNumb: phoneNumb,
      createdAt: serverTimestamp(),
    })
  }

  return { error, result }
}

export async function updateDocToSign(id, files) {
  const docRef = doc(db, "DocToSign", id)
  await setDoc(docRef, {
    files: files,
    idCard: id,
  })
}

export async function activateUserAccount(id) {
  let error = ""
  let result = ""

  const docRef = doc(db, "users", id)
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    const {
      approvalStatus,
      createdAt,
      displayName,
      loanNo,
      password,
      phoneNumb,
    } = docSnap.data()
    setTimeout(() => {
      updateUserData(
        approvalStatus,
        createdAt,
        displayName,
        password,
        loanNo,
        phoneNumb
      )
    }, 1000)
    result = "success"
  } else {
    error = "fail"
  }

  async function updateUserData(
    approvalStatus,
    createdAt,
    displayName,
    password,
    loanNo,
    phoneNumb
  ) {
    const userRef = doc(db, "users", id)
    await setDoc(userRef, {
      approvalStatus: approvalStatus,
      createdAt: createdAt,
      displayName: displayName,
      idCard: id,
      loanNo: loanNo,
      password: password,
      phoneNumb: phoneNumb,
      timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
    })
  }
  return { error, result }
}

export async function ChangeApprovalStatus(id, approvalStatus) {
  let error = ""
  let result = ""

  const docRef = doc(db, "users", id)
  const docSnap = await getDoc(docRef)
  if (docSnap.exists()) {
    const { displayName, password, loanNo, phoneNumb } = docSnap.data()
    setTimeout(() => {
      updateUserData(displayName, password, loanNo, approvalStatus, phoneNumb)
    }, 1000)
    result = "success"
  } else {
    error = "fail"
  }

  async function updateUserData(
    displayName,
    password,
    loanNo,
    approvalStatus,
    phoneNumb
  ) {
    const userRef = doc(db, "users", id)
    await setDoc(userRef, {
      idCard: id,
      password: password,
      displayName: displayName,
      approvalStatus: approvalStatus,
      loanNo: loanNo,
      phoneNumb: phoneNumb,
      timestamp: moment().format("MMMM Do YYYY, h:mm:ss a"),
      createdAt: serverTimestamp(),
    })
  }
  return { error, result }
}
